

function Validation(values) {
    let error = {};
    const mobile_pattern = /^[0-9]{10}$/;
    const otp_pattern = /^\d{0,6}$/;

    if (values.mobile === '') {
        error.mobile = "Please enter valid Mobile Number"
    }
    else if (!mobile_pattern.test(values.mobile)) {
        error.mobile = "Please enter valid Mobile Number"
    }
    else {
        error.mobile = ""
    }




    if (values.otp === '') {
        error.otp = "Enter OTP"
    }

    else {
        error.otp = ""
    }
    return error
}

export default Validation